import React from 'react';
import { Skeleton } from 'antd';
import { SummarizationDrawerProps } from 'summarization/SummarizationDrawerProps';

const LazyAIAssistantDrawer = React.lazy(() => import('./AIAssistantDrawer'));

export const AsyncAIAssistantDrawer: React.FC<SummarizationDrawerProps> = props => {
	return (
		<React.Suspense
			fallback={<Skeleton active paragraph={{ rows: 4 }} title={{ width: '100%' }} />}
		>
			<LazyAIAssistantDrawer {...props} />
		</React.Suspense>
	);
};
